import { ReactNode } from 'react';

import { FormikOption } from 'src/general/components/forms/FormikInput/FormikInput.types';
import { PlpStoreState } from 'src/stores/plpStoreLegacy';
import { FilterListPayload } from 'src/types/CarFilters.types';

export interface FilterOptions {
  /** List of makes/models ordered by makes with highest number of cars associated with and models alphabetically */
  makeModel: FilterOptionHierarchy[];
  priceCash: FormikOption[];
  priceFinance: FormikOption[];
  year: FormikOption[];
  kilometers: FormikOption[];
  transmission: FormikOption[];
  fuelType: FormikOption[];
  highlightedFeatures: FormikOption[];
  bodyType: FilterOptionHierarchy[];
  driveType: FormikOption[];
  seats: FormikOption[];
  doors: FormikOption[];
  colour: FormikOption[];
  co2Emissions: FormikOption[];
  ancapSafetyRating: FormikOption[];
}

export interface FilterOptionHierarchy extends FormikOption {
  children: (FormikOption & { labelNoCount: ReactNode })[];
  labelNoCount: ReactNode;
}

export interface PlpFiltersProps
  extends Pick<PlpStoreState, 'filters' | 'setFilters' | 'listingOptions' | 'setListingOptions'> {
  filterData?: FilterListPayload;
  filterOptions?: FilterOptions;
}

export const PLP_FILTER_SUBMIT_DEBOUNCE = 50;
